module.exports = __webpack_public_path__ + "resources/img/img_secure_center01_m_jp.c9adc2bfe02251bbeb79b48d5350bd2c.png";